interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Figma 75644:18518 "expand-arrows-alt 1" — four arrows pointing outward. */
const FigmaZoomInIcon = ({ width = 20, height = 20, color = '#121826' }: Properties) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16.6667 3.9225L20 7.25583V1.25C20 0.560833 19.4392 0 18.75 0H12.7442L16.0775 3.33333L10 9.41083L3.9225 3.33333L7.25583 0H1.25C0.560833 0 0 0.560833 0 1.25V7.25583L3.33333 3.9225L9.41083 10L3.33333 16.0775L0 12.7442V18.75C0 19.4392 0.560833 20 1.25 20H7.25583L3.9225 16.6667L10 10.5892L16.0775 16.6667L12.7442 20H18.75C19.4392 20 20 19.4392 20 18.75V12.7442L16.6667 16.0775L10.5892 10L16.6667 3.9225ZM18.75 0.833333C18.98 0.833333 19.1667 1.02083 19.1667 1.25V5.24417L14.7558 0.833333H18.75ZM0.833333 1.25C0.833333 1.02083 1.02 0.833333 1.25 0.833333H5.24417L0.833333 5.24417V1.25ZM1.25 19.1667C1.02 19.1667 0.833333 18.9792 0.833333 18.75V14.7558L5.24417 19.1667H1.25ZM19.1667 18.75C19.1667 18.9792 18.98 19.1667 18.75 19.1667H14.7558L19.1667 14.7558V18.75Z'
      fill={color}
    />
  </svg>
);

export default FigmaZoomInIcon;
